// Keeps co-located venue pins from fully covering each other.
//
// Pins whose projected centres are closer than MIN_SEPARATION_RATIO × the
// pin's visual diameter are pushed apart through MapLibre's own
// `Marker.setOffset()` (a pixel offset added inside MapLibre's transform),
// so MapLibre keeps full ownership of the marker element's `transform`.
// A few relaxation passes resolve chains (A pushed into B pushed into C);
// pins that no longer collide at the current zoom return to a zero offset,
// so at street level distinct venues sit on their exact coordinates.

// 0.5 → at most ~40% of a pin's area can be hidden by a neighbour.
export const MIN_SEPARATION_RATIO = 0.5;
const MAX_PASSES = 8;

function applyOffset(marker, dx, dy) {
  const nx = Math.round(dx);
  const ny = Math.round(dy);
  const current = marker.getOffset();
  if (current.x === nx && current.y === ny) return;
  marker.setOffset([nx, ny]);
}

export function spreadOverlappingMarkers(map, markers, visualDiameter) {
  if (!map) return;
  const minSep = visualDiameter * MIN_SEPARATION_RATIO;
  const pts = markers.map((marker) => {
    const p = map.project(marker.getLngLat());
    return { marker, ox: p.x, oy: p.y, x: p.x, y: p.y };
  });

  for (let pass = 0; pass < MAX_PASSES; pass += 1) {
    let moved = false;
    for (let i = 0; i < pts.length; i += 1) {
      for (let j = i + 1; j < pts.length; j += 1) {
        const a = pts[i];
        const b = pts[j];
        const dx = b.x - a.x;
        const dy = b.y - a.y;
        const d = Math.hypot(dx, dy);
        if (d >= minSep - 0.01) continue;
        // Coincident pins (same building) split horizontally, deterministic by order.
        const ux = d < 0.01 ? 1 : dx / d;
        const uy = d < 0.01 ? 0 : dy / d;
        const half = (minSep - d) / 2;
        a.x -= ux * half; a.y -= uy * half;
        b.x += ux * half; b.y += uy * half;
        moved = true;
      }
    }
    if (!moved) break;
  }

  pts.forEach((p) => applyOffset(p.marker, p.x - p.ox, p.y - p.oy));
}
